import { from, Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { AuthService } from '#services/shared';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Utility } from '#services/shared/utility';
import * as MsalUtils from 'app/msal/utils';
import { environment } from '#environments/environment';
import { Account, AuthResponse, ServerHashParamKeys } from 'msal';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authServ: AuthService,
    private msalService: MsalService,
    private broadcastService: BroadcastService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isB2C = window.location.pathname === '/b2c';
    const isB2cLogged = this.authServ.isb2cLoged();

    if (isB2cLogged) {
      return next.handle(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.authServ.b2cResp.access_token}`,
          },
        })
      );
    }

    if (isB2C && Utility.validateEnvironment() && !isB2cLogged) {
      return next.handle(request);
    }

    const scopes = this.msalService.getScopesForEndpoint(request.url);
    if (scopes && scopes.length === 0) {
      return next.handle(request);
    }

    const acct = this.msalService.getAccount();
    if (acct === null) {
      return next.handle(request);
    }

    if (MsalUtils.isIframe) {
      return next.handle(request);
    }

    let accessToken = '';
    return from(
      this.aquireTokenSilent(scopes, acct)
        .then((response: AuthResponse) => {
          accessToken = response.tokenType === ServerHashParamKeys.ID_TOKEN ? response.idToken.rawIdToken : response.accessToken;

          return request.clone({
            setHeaders: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
        })
    ).pipe(
      mergeMap((authRequest) => next.handle(authRequest)),
      tap(
        () => {
          //
        },
        (error) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.msalService.clearCacheForScope(accessToken);
            this.broadcastService.broadcast(
              'msal:notAuthorized',
              error.message
            );
          }
        }
      )
    );
  }
  aquireTokenSilent(scopes: string[], acct: Account): Promise<AuthResponse> {
    if (Utility.isIOS()) {
      return this.msalService
        .acquireTokenSilent({
          loginHint: acct.userName,
          scopes: [environment.cal.auth.clientId],
        });

    }
    return this.msalService
      .ssoSilent({
        loginHint: acct.userName,
        scopes,
      });

  }
}
